import { render } from "./AnnotationTypeFilter.vue?vue&type=template&id=d2e26b2e&scoped=true"
import script from "./AnnotationTypeFilter.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeFilter.vue?vue&type=script&lang=js"

import "./AnnotationTypeFilter.vue?vue&type=style&index=0&id=d2e26b2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2e26b2e"]])

export default __exports__